import { render } from "./Municipe.vue?vue&type=template&id=67fb27c0"
import script from "./Municipe.vue?vue&type=script&lang=js"
export * from "./Municipe.vue?vue&type=script&lang=js"

import exportComponent from "/media/whoami/010101010/Prosofty/PublicOpinion/frontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__